import { render, staticRenderFns } from "./TagInsertion.vue?vue&type=template&id=687b6235"
import script from "./TagInsertion.vue?vue&type=script&lang=js"
export * from "./TagInsertion.vue?vue&type=script&lang=js"
import style0 from "./TagInsertion.vue?vue&type=style&index=0&id=687b6235&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports